"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = LNumInp;
var jsx_runtime_1 = require("react/jsx-runtime");
var handlers_1 = require("../../../../lib/handlers");
var react_1 = require("react");
var recent = {};
function LNumInp(_a) {
    var _b, _c;
    var title = _a.title, group = _a.group, id = _a.id, name = _a.name, large = _a.large, s = _a.s, d = _a.d, r = _a.r;
    var pascalId = "".concat((_b = id === null || id === void 0 ? void 0 : id.charAt(0).toUpperCase()) !== null && _b !== void 0 ? _b : "").concat((_c = id === null || id === void 0 ? void 0 : id.slice(1)) !== null && _c !== void 0 ? _c : "");
    var joinedTitle = title.replace(/[\s\|]/g, "");
    var optRef = (0, react_1.useRef)(null);
    var dlRef = (0, react_1.useRef)(null);
    var sanitazeValue = function (n) {
        var _a;
        if (/[^0-9,\.]/g.test(n))
            n = n.replace(/[^0-9,\.]/g, "");
        if (n.length > 11)
            n = n.slice(0, 11);
        var _b = n.split(/[,.]/), integerPart = _b[0], decimalPart = _b[1];
        var sanitizedInteger = integerPart ? integerPart.slice(0, 5) : "";
        var sanitizedDecimal = /[0-9]/g.test(decimalPart)
            ? ".".concat(decimalPart.slice(0, 5))
            : "";
        return (_a = "".concat(sanitizedInteger).concat(sanitizedDecimal)) !== null && _a !== void 0 ? _a : "0";
    };
    (0, react_1.useEffect)(function () {
        var handleResize = function () {
            if (optRef.current instanceof HTMLElement &&
                r.current instanceof HTMLElement) {
                var prevHeight = getComputedStyle(optRef.current).height;
                optRef.current.style.height = "".concat(getComputedStyle(r.current)
                    .height.replace("px", "")
                    .trim(), "px");
                if ((0, handlers_1.parseNotNaN)(getComputedStyle(optRef.current).height.replace("px", "").trim()) <= 0)
                    optRef.current.style.height = prevHeight;
            }
        };
        addEventListener("resize", handleResize);
        return function () { return removeEventListener("resize", handleResize); };
    }, [r]);
    (0, react_1.useEffect)(function () {
        try {
            if (!(r.current instanceof HTMLInputElement))
                return;
            if (!(dlRef.current instanceof HTMLDataListElement))
                return;
            sessionStorage.setItem("v", s);
            if (s !== "") {
                if (!recent["".concat(r.current.id)])
                    recent["".concat(r.current.id)] = [];
                if (!recent["".concat(r.current.id)].includes(s)) {
                    recent["".concat(r.current.id)].push(s);
                    if (recent["".concat(r.current.id)].length > 3)
                        recent["".concat(r.current.id)].shift();
                    dlRef.current.innerHTML = "";
                    recent["".concat(r.current.id)].forEach(function (value) {
                        var _a;
                        (_a = dlRef.current) === null || _a === void 0 ? void 0 : _a.appendChild(Object.assign(document.createElement("option"), {
                            value: value,
                        }));
                    });
                }
            }
        }
        catch (e) {
            console.error("Error executing interv for filling datalist at ".concat(new Date().getMilliseconds(), ":\n").concat(e.message));
        }
    }, [s, r]);
    return ((0, jsx_runtime_1.jsxs)("fieldset", { id: "fs".concat(pascalId), "data-title": title, className: large ? "calc-group-large" : "calc-group", children: [(0, jsx_runtime_1.jsx)("label", { id: "lb".concat(pascalId), htmlFor: id, className: "calc-lab", "data-title": title, children: (0, jsx_runtime_1.jsx)("b", { children: /__/g.test(title)
                        ? "".concat(title.slice(0, title.indexOf("__")), ":")
                        : "".concat(title, ":") }) }), (0, jsx_runtime_1.jsxs)("div", { id: "div".concat(pascalId), className: "calc-inp-div", "data-title": joinedTitle, children: [(0, jsx_runtime_1.jsx)("input", { id: id, className: "form-control calc-inp", name: name, title: "Digite aqui o valor de solo para ser avaliado. Use . para decimais.", placeholder: "Digite aqui os litros de solo.", "data-title": joinedTitle, "data-group": group, type: "number", pattern: "^[0-9]{1,11}$", min: 0, max: 99999, minLength: 1, maxLength: 11, autoComplete: "off", list: "dl".concat(pascalId), ref: r, value: s, onKeyDown: function (k) {
                            if (k.key === "+" || k.key === "-")
                                k.preventDefault();
                        }, onInput: function (ev) { return d(sanitazeValue(ev.currentTarget.value)); }, onChange: function (ev) { return d(sanitazeValue(ev.currentTarget.value)); } }), (0, jsx_runtime_1.jsx)("datalist", { id: "dl".concat(pascalId), "data-title": joinedTitle, "data-group": group, ref: dlRef }), (0, jsx_runtime_1.jsx)("abbr", { id: "select".concat(pascalId), className: "calc-measure", ref: optRef, "data-title": joinedTitle, children: "L" })] })] }));
}
